import Vue from "vue";
import VueGridLayout from "vue-grid-layout";

Vue.component("GridLayout", VueGridLayout.GridLayout);
Vue.component("GridItem", VueGridLayout.GridItem);
